<template>
  <div class="top-sale pt-9 bg-grey-lighten-4">
    <div
      class="title d-flex justify-center justify-space-between mb-5"
      style="border-bottom: 2px solid #000"
      dir="rtl"
    >
      <h3 class="h3w">
        كتب علم النفس
        <span
          style="
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 5px; /* Height of the border */
            background-color: #000; /* Color of the border */
            border-top-left-radius: 10px; /* Top-left corner rounded */
            border-top-right-radius: 10px; /* Top-right corner rounded */
          "
        ></span>
      </h3>
      <span class="pl-8 hover-effect" style="cursor: pointer">
        <router-link
          :to="{
            name: 'products_category',
            query: {
              category: 'كتب-علم-النفس',
            },
          }"
          style="color: #333333; text-decoration: none"
          >مشاهدة المزيد</router-link
        ></span
      >
    </div>
    <!-- Swiper Container -->
    <swiper
      v-if="products.length >= 3"
      :autoplay="{
        delay: 3000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      }"
      :breakpoints="breakpoints"
      :loop="true"
      :modules="modules"
      :slides-per-view="3"
      :looped-slides="3"
      :navigation="navigationOptions"
      class="pb-15 responsive-swiper"
      dir="rtl"
      space-between="20"
    >
      <!-- Swiper Slides with v-card -->
      <swiper-slide v-for="item in products" :key="item.id">
        <v-card
          elevation="5"
          class="pb-5"
          style="
            border-radius: 15px;
            box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
          "
        >
          <div
            style="
              overflow: hidden;
              border-radius: 0 0 15px 15px;
              position: relative;
            "
          >
            <v-hover v-slot="{ isHovering, props }">
              <img
                @click="
                  $router.push({
                    name: 'products_details',
                    query: { productId: item.id },
                  })
                "
                v-bind="props"
                :src="item.image"
                alt="mizabook"
                :style="{
                  width: '100%',
                  transform: isHovering ? 'scale(1.09)' : 'scale(1)',
                  transition: '0.6s all ease-in-out',
                  cursor: 'pointer',
                  borderRadius: '0 0 15px 15px',
                }"
                @load="isImageLoaded = true"
                @error="handleImageError"
              />
              <div v-if="!isImageLoaded" class="loading-spinner"></div>
            </v-hover>
          </div>

          <v-card-text class="pb-1 d-flex justify-center font-weight-regular">
            <span class="name-text-multiline">{{ item.name }}</span>
          </v-card-text>

          <v-rating
            v-model="item.rating"
            half-increments
            readonly
            color="yellow-darken-2"
            size="small"
            dir="ltr"
            class="d-flex justify-center"
            density="compact"
          ></v-rating>

          <v-card-text class="pt-1 d-flex justify-center">
            <p style="text-align: center">
              <span class="text-red" style="font-weight: 800; font-size: 15px">
                <br />{{ item.price }} دم
              </span>
            </p>
          </v-card-text>

          <div class="d-flex justify-center">
            <v-btn
              density="compact"
              class="py-2 px-7"
              style="border-radius: 30px; text-transform: none; height: auto"
              variant="outlined"
              @click="
                $router.push({
                  name: 'products_details',
                  query: { productId: item.id },
                })
              "
            >
              شراء الآن
            </v-btn>
          </div>
        </v-card>
      </swiper-slide>

      <!-- Swiper Pagination -->

      <div class="swiper-prev"></div>
      <div class="swiper-next"></div>
      <div class="swiper-scrollbar"></div>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Pagination, Navigation, Scrollbar, Autoplay } from "swiper/modules"; // Correct module imports
import "swiper/swiper-bundle.css"; // Import swiper styles
import { ref, onMounted, computed } from "vue"; // Import ref and onMounted

export default {
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    isImageLoaded: false,
    breakpoints: {
      0: {
        slidesPerView: 2,
      },
      429: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 3,
      },
      990: {
        slidesPerView: 4,
      },
      1436: {
        slidesPerView: 5,
      },
    },
  }),
  setup() {
    const windowWidth = ref(window.innerWidth); // Reactive windowWidth

    const handleResize = () => {
      windowWidth.value = window.innerWidth; // Update the reactive width
    };

    // Add the resize listener when component is mounted
    onMounted(() => {
      window.addEventListener("resize", handleResize); // Add event listener for resizing
    });

    // Computed property for navigation options
    const navigationOptions = computed(() => {
      return windowWidth.value > 600
        ? { prevIcon: ".swiper-prev", nextIcon: ".swiper-next" }
        : false;
    });

    return {
      modules: [Pagination, Navigation, Scrollbar, Autoplay], // Correct Swiper modules
      windowWidth, // Expose windowWidth
      navigationOptions, // Expose navigationOptions
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize); // Clean up the event listener
  },
  methods: {
    handleImageError(event) {
      // Provide a fallback image if the original image fails to load
      event.target.src = require("@/assets/placeholder-image.gif");
    },
  },
};
</script>
<style lang="scss">
@import url("https://fonts.google.com/noto/specimen/Noto+Kufi+Arabic?lang=ar_Arab");
.loading-spinner {
  width: 50px;
  height: 50px;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.hover-effect {
  font-weight: 600;
  font-size: 13px;
  transition: transform 0.3s ease; /* Smooth transition for the hover effect */
}

.hover-effect:hover {
  transform: scale(1.03); /* Scale up the element on hover */
  color: #34383b; /* Change color on hover if desired */
}
.h3w {
  font-weight: 900;
  font-size: 30px;
  position: relative;
  display: inline-block;
  padding-bottom: 5px;
  padding-right: 10px; /* Adjust margin as needed */
  padding-left: 20px; /* Adjust margin as needed */
}
.title {
  font-family: "Noto Kufi Arabic", sans-serif;
}
.swiper-scrollbar.swiper-scrollbar-horizontal {
  bottom: 0;
  height: 7px;
}
.swiper-scrollbar {
  background-color: rgb(212, 212, 212);
  max-width: 900px;
  right: 50%;
  transform: translateX(50%);
}

.swiper-scrollbar .swiper-scrollbar-drag {
  /* Make it circular */
  background-color: rgb(145, 145, 145);
  height: 7px; /* Height of the ball */
  &:active,
  &:hover {
    background-color: rgb(94, 94, 94);
  }
}
.top-sale {
  .swiper-button-next,
  .swiper-button-prev {
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1.2px solid #598bc0;
    border-radius: 50%;
    top: 48%;
    background-color: #598bc0;
    transition: 0.4s all ease-in-out;
    color: rgb(0, 0, 0);
    &:hover {
      border: 1.2px solid #406388;
      transform: scale(1.1);
      transition: 0.4s all ease-in-out;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
      background-color: #406388; /* Darker shade on hover */
      color: white;
    }
    &::after {
      font-size: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.name-text {
  white-space: nowrap; /* Keeps the text in one line */
  overflow: hidden; /* Ensures content overflows are hidden */
  text-overflow: ellipsis; /* Adds ... for overflowed content */
  max-width: 250px; /* Adjust this value to fit your design */
  display: inline-block; /* To ensure the text respects the max-width */
}

/* Optional for multi-line truncation */
.name-text-multiline {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  overflow: hidden;
  text-overflow: ellipsis;

  line-height: 1.5;
  height: 3em; /* ديما بلاصة جوج سطور */
  max-width: 250px;
  text-align: center;
}
@media (max-width: 768px) {
  .name-text-multiline {
    max-width: 200px; /* Adjust for smaller screens */
  }
}
.responsive-swiper {
  width: 80%;
}
@media (max-width: 600px) {
  .responsive-swiper {
    width: 95%;
  }
}
</style>
